// extracted by mini-css-extract-plugin
module.exports = {"Text":"styles_Text__Pxq_G","Button":"styles_Button__BpRRv"};